var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBellSlashIcon = function SvgBellSlashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.944 16.244-12.5-13.75a.937.937 0 1 0-1.388 1.261l1.157 1.273a6.53 6.53 0 0 0-.775 3.097c0 1.998-.359 3.672-1.037 4.838a1.568 1.568 0 0 0 .566 2.143c.238.137.508.209.783.207h2.827a3.438 3.438 0 0 0 6.846 0h.14l1.993 2.193a.938.938 0 0 0 1.388-1.262ZM5.313 8.125c-.001-.54.092-1.077.275-1.585l6.27 6.897H4.272c.69-1.406 1.04-3.192 1.04-5.312ZM10 16.563a1.562 1.562 0 0 1-1.531-1.25h3.062a1.563 1.563 0 0 1-1.53 1.25ZM6.945 3.309a.938.938 0 0 1 .497-1.23 6.563 6.563 0 0 1 9.12 6.046c0 1.46.186 2.729.553 3.772a.937.937 0 1 1-1.769.625c-.437-1.247-.658-2.725-.658-4.397a4.687 4.687 0 0 0-6.514-4.319.937.937 0 0 1-1.23-.497Z",
    fill: "currentColor"
  })));
};

export default SvgBellSlashIcon;